import React, { useMemo, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import {
  CellLeftV8,
  order2Sorting,
  EditCellV8,
  TableCellV8,
  TablePaginatedV8,
  CellYesNoV8,
  CellYesNoEngV8,
  EyeColumnV8,
} from 'motion-components';
import { useLocation } from 'react-router-dom';
import { generatePath, useHistory } from 'react-router';
import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { gridInactiveRowStyle, gridRowSelectedStyle } from 'shared-pages/common/grid-helpfunc';
import { getRouteByName } from 'app/routes';

export const DataGrid = forwardRef((props: any, ref) => {
  const {
    data,
    initPageIndex,
    onPageChange,
    loading,
    handleExport,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
    refetch,
    dataCount,
  } = props;

  const location = useLocation<any>();
  const history = useHistory();
  const { appStore, tableStore } = useRootStore();
  const { t, i18n } = useTranslation();

  const rowClicked = useCallback(
    (row) => {
      history.push({
        pathname: generatePath(getRouteByName('Postalcodes2Form'), { id: row.id }),
        state: {
          // pathname: location.pathname,
          // ...location.state,
        },
      });
    },
    [history, location.pathname, location.state],
  );

  const columns = useMemo(
    () => [
      EyeColumnV8(rowClicked),
      {
        id: 'postalcode',
        header: t('T.K.'),
        accessorKey: 'postalcode',
        orderByField: 'postalcode',
        columnName: t('T.K.'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 20,
      },
      {
        id: 'area',
        header: t('Περιοχή'),
        accessorKey: 'area',
        orderByField: 'area',
        columnName: t('Περιοχή'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 30,
      },
      {
        id: 'city',
        header: t('Πόλη'),
        accessorKey: 'city',
        orderByField: 'city',
        columnName: t('Πόλη'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 30,
      },
      {
        id: 'county',
        header: t('Νομός'),
        accessorKey: 'county',
        orderByField: 'county',
        columnName: t('Νομός'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 30,
      },
      {
        id: 'regionId',
        header: t('Περιφέρεια'),
        accessorKey: 'region.name',
        orderByField: 'regionId',
        columnName: t('Περιφέρεια'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 30,
      },
      {
        id: 'country',
        header: t('Χώρα'),
        accessorKey: 'country',
        orderByField: 'country',
        columnName: t('Χώρα'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 30,
      },
    ],
    [t, i18n.language],
  );

  const tableRef = useRef(null);

  useImperativeHandle(ref, () => tableRef.current || null);

  return (
    <LoadingOverlay active={loading} spinner text={'Παρακαλώ περιμένετε...'}>
      {data ? (
        <TablePaginatedV8
          ref={tableRef}
          loading={loading}
          id="grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={dataCount}
          onRowClick={(table) => setSelected(table.row.original)}
          rowProps={(row: any) => {
            let style = undefined;
            if (row.original.id === selected?.id) style = gridRowSelectedStyle;
            if (row.original.isActive === false) style = { ...style, ...gridInactiveRowStyle };
            return { style };
          }}
          onExport={handleExport}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          initSorting={order2Sorting(initOrderBy)}
          onSortByChange={(sort, columnDef, orderBy) => {
            onOrderChange(orderBy);
          }}
          topBorderRadius={false}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
  );
});
